import * as S from "./styles";
import { TrackingEvents, ProductNames } from "@local-logic/core/tracking";
import { scoreCategories, Score } from "@local-logic/elements-react";
import React, { useState, useEffect } from "react";
import HomeSVG from "~/assets/icons/home.svg";
import PlaceSVG from "~/assets/icons/place.svg";
import { useStateManagerContext } from "~/context/stateManager";
import { useTracking } from "~/context/trackingProvider";
import useIsMobile from "~/hooks/useIsMobile";
import { useLocalContent } from "~/sdks/LocalContent/context";
import { useScores } from "~/sdks/LocalContent/features/useScores";
import { LocalContentProps } from "~/sdks/LocalContent/types";

const ScoreInfo = () => {
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  const { activeCategory, activeScore } = useLocalContent();
  const tracking = useTracking();
  const isMobile = useIsMobile();
  const currentScoreCategory = scoreCategories.find(
    (c) => c.value === activeCategory
  )!;
  const { data, isLoading } = useScores(currentScoreCategory.scores);

  const [isCtaClicked, setIsCtaClicked] = useState(false);

  const ctaClicked = () => {
    setIsCtaClicked(!isCtaClicked);
  };

  useEffect(() => {
    if (isCtaClicked) {
      tracking.postEvent({
        eventType: TrackingEvents.LOCALCONTENT_LONG_DESCRIPTION_CLICKED,
        product: ProductNames.LOCAL_CONTENT,
        isMobile,
        eventAttributes: [
          {
            label: "activeScore",
            data: activeScore.toString(),
          },
        ],
      });
    }

    return () => {
      setIsCtaClicked(false);
    };
  }, [isCtaClicked]);

  if (!(activeScore && data?.location[activeScore])) {
    return null;
  }

  if (isLoading) {
    return <div>Loading</div>;
  }

  return (
    <Score.Root
      options={{
        score: activeScore,
        scoresData: data,
      }}
    >
      <S.ScoreInfo>
        <S.ScoreContainer>
          <Score.Badge />
          <Score.BarChart
            options={{
              renderNeighbourhoodAvg: false,
              locationIcon: (sdkState.options?.marker?.icon === "pin"
                ? PlaceSVG
                : HomeSVG) as unknown as React.FC,
            }}
          />
        </S.ScoreContainer>
        <Score.Description ctaClicked={ctaClicked} />
      </S.ScoreInfo>
    </Score.Root>
  );
};

export default ScoreInfo;
